import * as React from "react";
import { SVGProps } from "react";
const SvgLangSelect = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.302 24.463c1.181-1.936 1.941-4.536 2.085-7.463h2.562c-.302 3.038-1.976 5.671-4.386 7.293l-.261.17ZM6.051 17h2.563c.143 2.927.905 5.527 2.085 7.464-2.462-1.549-4.21-4.131-4.61-7.14L6.05 17h.001Zm4.648-9.464C9.519 9.472 8.757 12.073 8.614 15H6.051c.303-3.038 1.977-5.673 4.387-7.294l.261-.17ZM17 15V6.185c2.304.833 4.142 4.459 4.389 8.815H17Zm0 10.815V17h4.389c-.24 4.245-1.992 7.797-4.213 8.746l-.176.069ZM15 17v8.815c-2.303-.832-4.141-4.458-4.388-8.815H15Zm0-10.814V15h-4.388c.24-4.244 1.992-7.796 4.212-8.745L15 6.186ZM25.949 15h-2.562c-.143-2.927-.904-5.527-2.085-7.463 2.462 1.548 4.21 4.131 4.61 7.14l.037.323ZM16 4C9.384 4 4 9.383 4 16s5.384 12 12 12c6.617 0 12-5.383 12-12 0-6.515-5.219-11.834-11.695-11.996L16 4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLangSelect;
